export class Metrics {
  private frameTimes: number[] = [];
  private detectMs = 0;
  private warpMs: number | null = null;
  private loadMs: number | null = null;

  recordLoad(ms: number) {
    this.loadMs = ms;
  }

  recordDetect(ms: number) {
    this.detectMs = ms;
  }

  recordWarp(ms: number) {
    this.warpMs = ms;
  }

  tickFrame() {
    const now = performance.now();
    this.frameTimes.push(now);
    while (this.frameTimes.length > 0 && now - this.frameTimes[0] > 1000) {
      this.frameTimes.shift();
    }
  }

  snapshot() {
    return {
      fps: this.frameTimes.length,
      detectMs: this.detectMs,
      warpMs: this.warpMs,
      loadMs: this.loadMs,
    };
  }
}
